<template>
    <!-- Newsletter -->
	<div class="newsletter-section bg-gradient-green">
        <div class="container newsletter--container">
            <!-- Intro -->
            <div class="newsletter-title">
                <div
                    class="text-center fast"
                    v-scroll="handleScroll"
                    data-scroll-class="animated fadeInDown"
                    data-scroll-button-distance="400"
                    data-scroll-once="true"
                    data-scroll-animation-rate="1.04">
                    <h1>Regístrate en nuestro Newsletter para saber más:</h1>
                </div>
                <div class="newsletter--content">
                    <p>Recibirás notificaciones sobre nuevas actualizaciones e informaciones que te ayudaran con el manejo de tus tarjetas.</p>
                    <sign-up-form class="" :standalone-mode="true"/>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    name: 'NewsletterSection'
}
</script>
<style lang="scss" scoped>
.newsletter-section {
    padding: 60px 0;
    max-height: 334px;
    height: 100%;

    .newsletter--container {
        max-width: 640px;
        width: 100%;

        .newsletter-title {
            text-align: center;
            color: $white-color;

            h1 {
                font-family: $primary-font;
                font-size: $medium-font-size;
            }
        }

        .newsletter--content {
            p {
                font-size: $small-font-size;
            }
        }
    }
}
// Medium devices (mobile, 575px)
@media screen and (max-width: 575px) {
	.newsletter-section {
		max-height: 100%;
	}
}

// Medium devices (mobile, 692px)
@media screen and (max-width: 692px) {
	.newsletter-section {
		.newsletter--container {
            padding-right: 1.5rem;
            padding-left: 1.5rem;
        }
	}
}
</style>